import CryptoJS from 'crypto-js';

// Khóa mã hóa - trong môi trường thực tế nên lưu trong biến môi trường
const SECRET_KEY = 'DCX_BOOKING_SECRET_KEY'; 

export const encryptData = (data) => {
  try {
    const dataString = JSON.stringify(data);
    return CryptoJS.AES.encrypt(dataString, SECRET_KEY).toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

export const decryptData = (ciphertext) => {
  try {
    if (!ciphertext) return null;
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// Utility functions cho localStorage
export const secureLocalStorage = {
  setItem: (key, value) => {
    const encrypted = encryptData(value);
    localStorage.setItem(key, encrypted);
  },
  
  getItem: (key) => {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;
    return decryptData(encrypted);
  },
  
  removeItem: (key) => {
    localStorage.removeItem(key);
  }
};

// Tạo token cho booking IDs
export const createBookingToken = (bookingIds) => {
  if (Array.isArray(bookingIds)) {
    bookingIds = bookingIds.join(',');
  }
  return encryptData(bookingIds);
};

// Giải mã token booking
export const decryptBookingToken = (token) => {
  const decrypted = decryptData(token);
  return decrypted ? decrypted.split(',') : [];
};

export const decryptToken = (token) => {
  try {
    if (!token) return null;
    
    // Decrypt the token
    const bytes = CryptoJS.AES.decrypt(token, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    
    // Return the decrypted string (don't parse as JSON since it's a comma-separated list)
    return decryptedData;
  } catch (error) {
    console.error('Token decryption error:', error);
    return null;
  }
};